import "core-js/modules/es6.array.map.js";
import Transaction from "../../models/Transaction";
export var setTransactions = function setTransactions(state, payload) {
  state.transactions = payload.map(function (txn) {
    return new Transaction(txn);
  });
};
export var reset = function reset(state) {
  state.transactions = null;
};